<template>
  <CRow class="">
    <slot></slot>
  </CRow>
</template>

<script>
export default {
  name: 'DashboardTiles',
  inject: {
    state: {
      default: false
    }
  },
}
</script>
